import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path d='M19.98 2.99a1 1 0 00-.687.303l-3.998 3.998-1.28-1.281A.595.595 0 0013 6.43v3.974c0 .33.266.596.594.596h3.974c.53 0 .795-.64.42-1.016L16.71 8.705l3.998-3.998a1 1 0 00-.727-1.717zM6.43 13c-.53 0-.795.64-.42 1.016l1.281 1.279-3.998 3.998a1 1 0 101.414 1.414l3.998-3.998 1.28 1.28a.595.595 0 001.015-.42v-3.975a.595.595 0 00-.596-.594H6.43z'/>
    </svg>
  );
}

export default Icon;
